export default __webpack_public_path__ + "static/media/cloud.1da7309b.webp";